import RestService from './RestService';

export default class AwareExposeAdminService extends RestService {
    constructor(companiesService, companyId) {
        if (!companiesService || !companyId) {
            throw new Error('Companies service and companyId are required');
        }
        super(`${companiesService.baseUrl}/${companyId}/aware-expose-admin`);
        this.companyId = companyId;
    }

    config() {
        return this.get(`${this.baseUrl}/config`);
    }

    dashboard() {
        return this.get(`${this.baseUrl}/dashboard`);
    }

    listCampaigns() {
        return this.get(`${this.baseUrl}/campaigns`);
    }

    getCampaign(campaignId) {
        return this.get(`${this.baseUrl}/campaigns/${campaignId}`);
    }

    createCampaign(payload) {
        return this.post(`${this.baseUrl}/campaigns`, payload);
    }

    updateCampaign(campaignId, payload) {
        return this.put(`${this.baseUrl}/campaigns/${campaignId}`, payload);
    }

    deleteCampaign(campaignId) {
        return this.del(`${this.baseUrl}/campaigns/${campaignId}`);
    }

    launchCampaign(campaignId, payload) {
        return this.post(
            `${this.baseUrl}/campaigns/${campaignId}/launch`,
            payload || {}
        );
    }

    sendReminders(campaignId) {
        return this.post(
            `${this.baseUrl}/campaigns/${campaignId}/reminders`,
            {}
        );
    }

    cancelCampaign(campaignId) {
        return this.post(
            `${this.baseUrl}/campaigns/${campaignId}/cancel`,
            {}
        );
    }
}
